import React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Building24Regular } from '@fluentui/react-icons';
import type { Country } from '../../store/types';
import { getMicrosoftEntity } from '../../utils/microsoftEntity';

interface MicrosoftEntityBannerProps {
  country: Country | null;
}

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorBrandBackground2,
    borderRadius: tokens.borderRadiusMedium,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    marginTop: tokens.spacingVerticalM,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: tokens.colorBrandForeground1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    minWidth: 0,
  },
  label: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightRegular,
  },
  warningText: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
});

export const MicrosoftEntityBanner: React.FC<MicrosoftEntityBannerProps> = ({ country }) => {
  const styles = useStyles();

  const entityInfo = getMicrosoftEntity(country);

  if (!entityInfo) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <div className={styles.iconContainer}>
        <Building24Regular />
      </div>
      <div className={styles.content}>
        <span className={styles.warningText}>{entityInfo.warningText}</span>
      </div>
    </div>
  );
};
